<template>
    <div>
        <div class="main_box px1005 box950" style="padding-left:30px;">
               <nav>
                   <a class="maincolor" href="/">首页</a> <span class="c-666 en">&gt;</span>用户评价
               </nav>
           </div>
           <div class="clear_div center_box" style="width: 1100px;">
               <!-- 左边 -->
               <!--<div class="i_left">
                <dl class="left_nav th clear_div">
                    <dt></dt>
                    <dd>
                        <a href="about"><span class="l_3"></span>关于我们</a>
                    </dd>
                    <dd class="light">
                        <a href="http://www.zy1dt.com/comment"><span class="l_6"></span>用户评价</a>
                    </dd>
                    <dd>
                        <a href="contact"><span class="l_5"></span>联系我们</a>
                    </dd>
                </dl>
                </div>-->
                <!--右边-->
                <div class="i_right" style="width: 982px;text-align:center;margin: 0 auto;float: none;">
                    <div class="intro comment" id="comment1"  style="width: 970px;text-align:center;">
                        <h2 class="titleh2">公益讲座</h2>
                        <div style="width: 970px;">
                            <div class="scroll">
                                <div class="scroll_left" id="LeftArr"></div>
                                <div class="pic" id="scrollPic" style="width: 910px;">
                                    <ul style="width: 910px;display:block;">
                                        <li style="width: 910px;display:block;" imga="1" class="imgli">
                                            <a href="javascript:void(0)" title="公益讲座">
                                            <img src="../../assets/images/pinjia02.jpg" width="910" height="672"></a>
                                        </li>
                                        <li style="width: 910px;display:block;" imga="2" class="imgli">
                                            <a href="javascript:void(0)" title="公益讲座">
                                            <img src="../../assets/images/pinjia4.jpg" width="910" height="672"></a>
                                        </li>
                                        <li style="width: 910px;display:block;" imga="3" class="imgli">
                                            <a href="javascript:void(0)" title="公益讲座">
                                            <img src="../../assets/images/pinjia03.jpg" width="910" height="672"></a>
                                        </li>
                                        <li style="width: 910px;display:block;" imga="4" class="imgli">
                                            <a href="javascript:void(0)" title="公益讲座">
                                            <img src="../../assets/images/pinjia5.jpg" width="910" height="672"></a>
                                        </li>
                                        <li style="width: 910px;display:none;" imga="5" class="imgli">
                                            <a href="javascript:void(0)" title="公益讲座">
                                            <img src="../../assets/images/pinjia6.jpg" width="910" height="672"></a>
                                        </li>
                                        <li style="width: 910px;display:none;" imga="6" class="imgli">
                                            <a href="javascript:void(0)" title="公益讲座">
                                            <img src="../../assets/images/pinjia01.jpg" width="910" height="672"></a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="scroll_right" id="RightArr"></div>
                            </div>
                        </div>
                    </div>

                    <div class="intro comment" id="comment2"  style="width: 970px;text-align:center;clear:both;">
                        <h2 class="titleh2">用户评论</h2>
                        <div style="width: 970px;">
                            <div class="scroll" style="width:985px;height:700px;">
                                <div class="pic" id="scrollPic" style="height:672px;overflow-y: scroll;">
                                    <ul>
                                        <li>
                                            <a href="javascript:void(0)" title="用户评价">
                                                <img src="../../assets/images/comment01.png" width="980" height="672">
                                                <img src="../../assets/images/pingjia.jpg" width="980" height="672">
                                                <img src="../../assets/images/pingjia2.png" width="980" height="672">
                                                <img src="../../assets/images/pingjia3.png" width="980" height="672">
                                                <img src="../../assets/images/pingjia4.png" width="980" height="672">
                                                <img src="../../assets/images/pingjia5.png" width="980" height="672">
                                                <img src="../../assets/images/pingjia6.png" width="980" height="672">
                                                <img src="../../assets/images/pingjia7.png" width="980" height="196">
                                                <img src="../../assets/images/pingjia8.png" width="980" height="196">
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
           </div>
    </div>
</template>
<script>
import $ from 'jquery';
export default {
data(){
    return{
        carousels:[
            {itemUrl:require("../../assets/images/pinjia01.jpg")},
            {itemUrl:require("../../assets/images/pinjia02.jpg")}
        ]
    };
},
methods:{
    // 轮播图左右点击事件
    leftAndRightClick(){
        // let imglen=2;
let showimg=1;
$("#LeftArr").on("click",function(e){
    if(showimg===1){
        let imgs=$(".imgli");
        for(let i=0;i<imgs.length;i++){
            let imga=imgs.eq(i).attr("imga");
            if(imga===showimg+""){
                if(i===0){
                    break;
                }else if(i===0){
                    // imgs[i-1].style.display="block";
                    // imgs[i].style.display="none";
                    // imgs[i+1].style.display="none";
                }
            }
        }
    }else if(showimg===2){
        let imgs2=$(".imgli");
        for(let i=0;i<imgs2.length;i++){
            let imga2=imgs2.eq(i).attr("imga");
            if(imga2===showimg+""){
                if(i===0){
                    break;
                }else if(i===1){
                    imgs2[i-1].style.display="block";
                    imgs2[i].style.display="none";
                    imgs2[i+1].style.display="none";
                }
            }
        }
        showimg=1;
    }else if(showimg>=3){
        let imgs3=$(".imgli");
        for(let i=0;i<imgs3.length;i++){
            let imga3=imgs3.eq(i).attr("imga");
            if(imga3===showimg+""){
                if(i===0){
                break;
                }else if(i===showimg-1){
                    imgs3[i-1].style.display="block";
                    imgs3[i].style.display="none";
                    imgs3[i-2].style.display="none";
                }
            }
        }
        showimg=showimg-1;
    }
        // console.log(showimg);
        // if(showimg>=0){
        //     let imgs=$(".imgli");
        //     let imga=imgs.eq(showimg).attr("imga");
        //     if(imga===0){
        //         return;
        //     }else if(imga>=1){
        //         for(let i=0;i<imgs.length;i++){
        //             if(i==imga){
        //                 imgs[i].style.display="block";
        //             }else{
        //                 imgs[i].style.display="none";
        //             }
        //         }
        //     }
        //     showimg--;
        // }else{
        //     showimg=0;
        // }
});
$("#RightArr").on("click",function(e){
    let imgss=$(".imgli");
    if(showimg===1){
        let imgs=$(".imgli");
        for(let i=0;i<imgs.length;i++){
            let imga=imgs.eq(i).attr("imga");
            if(imga===showimg+""){
                if(i===0){
                    imgs[i+1].style.display="block";
                    imgs[i].style.display="none";
                    imgs[i+2].style.display="none";
                }else if(i===imgs.length-1){
                    break;
                }
            }
        }
        showimg=2;
    }else if(showimg>=2&&showimg<imgss.length){
        let imgs2=$(".imgli");
        for(let i=0;i<imgs2.length;i++){
            let imga2=imgs2.eq(i).attr("imga");
            if(imga2===showimg+""){
                if(i===showimg-1){
                    imgs2[i+1].style.display="block";
                    imgs2[i-1].style.display="none";
                    imgs2[i].style.display="none";
                }else if(i===imgs2.length-1){
                    break;
                }
            }
        }
        showimg=showimg+1;
    }else if(showimg===imgss.length){
        let imgs3=$(".imgli");
        for(let i=0;i<imgs3.length;i++){
            let imga3=imgs3.eq(i).attr("imga");
            if(imga3===showimg+""){
                if(i===2){
                    // imgs3[i+1].style.display="block";
                    // imgs3[i-1].style.display="none";
                    // imgs3[i].style.display="none";
                }else if(i===imgs3.length){
                    break;
                }
            }
        }
    }

        // console.log(showimg);
        // let imgs=$(".imgli");
        // if(showimg>=1&&showimg<imgs.length-1){
        //     let imga=imgs.eq(showimg-1).attr("imga");
        //     if(imga===imgs.length-1){
        //         return;
        //     }else if(imga>=1&&imga<imgs.length-1){
        //         for(let i=0;i<imgs.length;i++){
        //             if(i==imga){
        //                 imgs[i].style.display="block";
        //             }else{
        //                 imgs[i].style.display="none";
        //             }
        //         }
        //     }
        //     showimg++;
        // }else{
        //     let imga=imgs.eq(showimg-1).attr("imga");
        //     showimg=imgs.length;
        // }
});
    }
},
mounted(){
    this.leftAndRightClick();
}
};
</script>
<style lang="less" scoped>
    .scroll_left{
            width: 23px;
            height: 63px;
            background: url(../../assets/images/btn_left.jpg) no-repeat;
            float: left;
            margin: 280px 5px 0 0;
            cursor: pointer;
    }
    .scroll_right{
        width: 23px;
        height: 63px;
        background: url(../../assets/images/btn_right.jpg) left no-repeat;
        float: left;
        margin: 280px 0px 0 5px;
        cursor: pointer;
    }
    .pic{
    height: 672px;
    float: left;
    overflow-y: hidden;
    }
    .mytabs{
    padding: 0;
    margin: 0 0 10px 25px;
    margin-bottom: 5px;
    margin-left: 0;
    list-style: none;
    width: 850px;
    position: relative;
    float: left;
    height: 50px;
    line-height: 50px;
    z-index: 1;
    border-bottom: 1px solid #ddd;
    }
    .titleh2{
    margin-bottom: 10px;
    text-align: center;
    line-height: 2;
    font-size: 30px;
    border-bottom:1px solid black;
    margin-bottom: 10px;
    }
    
h1,h2,h3,h4,h5,h6{
    margin: 0 !important;
    font-weight: 700 !important;
}
</style>
